import { defineComponent as _defineComponent } from 'vue'
import useFlags from '@/composables/useFlags'
  import ToggleSwitch from '@/components/common/ToggleSwitch.vue'
  import eventBus from '@/main'
  import { onMounted } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import { useRouter } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FlagsPanel',
  setup(__props) {

  const router = useRouter()
  const { flags } = useFlags()
  const flagsValues: { [key: string]: boolean } = flags

  for (const flagName of Object.keys(flags)) {
    const storageFlagName = 'flag-' + flagName
    const storageFlagValue = window.localStorage.getItem(storageFlagName)
    if (storageFlagValue) {
      flagsValues[flagName] = storageFlagValue === 'true'
    }
  }

  const toggleFlag = (flag: string, value: boolean): void => {
    if (flagsValues[flag] !== value) {
      flagsValues[flag] = value
      const storageFlagName = 'flag-' + flag
      if (value) {
        window.localStorage.setItem(storageFlagName, 'true')
      } else {
        window.localStorage.setItem(storageFlagName, 'false')
      }
      refreshApp()
    }
  }

  const refreshApp = (): void => {
    setTimeout(() => {
      eventBus.$emit('refresh')
    }, 1000)
  }

  onMounted(() => {
    if (!UserModule.isCompanyAdmin) {
      router.push('/trainings')
    }
    UserModule.setLoadingComponentViewData(false)
  })

return { __sfc: true,router, flags, flagsValues, toggleFlag, refreshApp, useFlags, ToggleSwitch, eventBus, onMounted, UserModule, useRouter }
}

})